import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TimeService } from 'src/app/time.service';
import { DateTime } from 'luxon';
import { HttpService } from 'src/app/http.service';
import { SnackbarService } from 'src/app/snackbar.service';


export enum Status {
  absent = "Absent",
  paid_leave = "Paid Leave",
  present = "Present",
  holiday = "Holiday"
}

@Component({
  selector: 'app-view-attendance',
  templateUrl: './view-attendance.component.html',
  styleUrls: ['./view-attendance.component.scss']
})
export class ViewAttendanceComponent implements OnInit {

  date_filter:any = {
    from_date: Date,
    to_date: Date,
  };
  months = [
    { name:'January',value:1 },
    { name:'February',value:2 },
    { name:'March',value:3 },
    { name:'April',value:4 },
    { name:'May',value:5 },
    { name:'June',value:6 },
    { name:'July',value:7 },
    { name:'August',value:8 },
    { name:'September',value:9 },
    { name:'October',value:10 },
    { name:'November',value:11 },
    { name:'December',value:12 },
  ];
  years = [2019,2020,2021];

  displayColumns = ['slno','date','type','comment'];
  holidayList = []


  filters:any = {
    month:'',
    year:''
  }
  showLoader =false;

  driver_data:any = {};

  selectedMonth;
  attendnanceFilters:any = {}
  constructor(private dialog: MatDialogRef<ViewAttendanceComponent>,private http:HttpService,private snackbar:SnackbarService,
    @Inject(MAT_DIALOG_DATA) private parentData: any,private timeService: TimeService) { }

  ngOnInit() {
    this.attendnanceFilters.driver = this.parentData.id;
    this.driver_data.driver_name = this.parentData.driver_name ? this.parentData.driver_name : 'N/A';
    this.driver_data.driver_mobile = this.parentData.driver_mobile ? this.parentData.driver_mobile : 'N/A';
    this.driver_data.driver_type = this.parentData.driver_type ? this.parentData.driver_type : 'N/A';
    this.setTime();
  }

  // set the time in the date picker
  setTime() {
    let current_month = new Date().getMonth();
    let current_year = new Date().getFullYear();
    if(current_month == 0){
      current_month = 12;
      current_year = current_year - 1;
    }
    this.filters.year = current_year;
    let month = this.months.filter((month)=>{
      return month.value == current_month
    })[0];
    this.filters.month = month.name;
    this.attendnanceFilters.month = current_month;
    this.attendnanceFilters.year = current_year;
    this.getAttendnanceDetails(this.attendnanceFilters);
  }


  getAttendnanceDetails(filter:any = {}){
    this.showLoader = true;
    this.http.get('driver/attendance/get',filter,3).subscribe((response:any)=>{
      this.showLoader = false;

      if(response.statusCode == 200){
        const data = response.data;
        this.driver_data.absent = data.absent_days ? data.absent_days : 0;
        this.driver_data.present = data.present_days ? data.present_days : 0;
        this.driver_data.paid_leaves = data.paid_leaves ? data.paid_leaves : 0;
        this.driver_data.total_days = data.total_days ? data.total_days : 0;
        this.driver_data.holidays = data.holidays ? data.holidays : 0;
        this.driver_data.daily_attendance = data.daily_attendance.length ? data.daily_attendance : [];
        this.holidayList = [];
        this.driver_data.daily_attendance.forEach((element,index)=>{
          const temp:any = {};

          temp.index = index + 1;
          temp.date_ = new Date(element.year,(element.month - 1),element.day);
          temp.date = DateTime.fromJSDate(temp.date_).toFormat('dd-MMM-yyyy').toLocaleString();
          temp.comment = element.comment ? element.comment : '--';
          temp.status = Status[element.status];

          this.holidayList.push(temp);
        });
      }
    },
    (err)=>{
      this.showLoader = false;
      this.snackbar.openSnackBar(err.error.message,'','err');
    });
  }

  selectMonth(month,event){
    this.selectedMonth = month;
    this.attendnanceFilters.month = month.value;
    this.getAttendnanceDetails(this.attendnanceFilters);
  }

  selectYear(year){
    this.attendnanceFilters.year = year;
    this.getAttendnanceDetails(this.attendnanceFilters);
  }

  closeDialog(){
    this.dialog.close();
  }

}
